import React, { useState, useEffect } from "react";
import PageHero from "../components/PageHero";
import { getGallery, getSettings } from "../api";
import { X, ArrowLeft, ArrowRight } from "lucide-react";

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [settings, setSettings] = useState({});
  const [zoom, setZoom] = useState(null);

  useEffect(() => {
    getGallery().then(d => setImages((d || []).map(g => g.image || g)));
    getSettings().then(setSettings);
  }, []);

  const next = () => setZoom((zoom+1) % images.length);
  const prev = () => setZoom((zoom-1+images.length) % images.length);

  return (
    <main>
      <PageHero title="Gallery" subtitle={settings.gallery_hero_subtitle || "A visual archive of pours, plants, fleet and the people who make it happen."} num="05"/>
      <section className="py-16 bg-[#fafafa]">
        <div className="max-w-[1500px] mx-auto px-5 md:px-8">
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
            {images.map((src, i) => {
              const heights = ['h-[280px]','h-[380px]','h-[320px]','h-[420px]','h-[300px]'];
              return (
                <button key={i} onClick={()=>setZoom(i)} className={`group relative w-full ${heights[i % heights.length]} block overflow-hidden rounded-2xl bg-white border border-[#ececef] hover:border-[#ef2435] transition-colors shadow-sm`}>
                  <img src={src} alt="" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"/>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"/>
                  <span className="absolute bottom-3 left-4 font-mono text-[10px] text-white tracking-widest font-semibold">[ IMG_{String(i+1).padStart(3,'0')} ]</span>
                </button>
              );
            })}
          </div>
        </div>
      </section>
      {zoom !== null && (
        <div className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-5">
          <button onClick={()=>setZoom(null)} className="absolute top-5 right-5 w-12 h-12 rounded-full bg-white/10 hover:bg-[#ef2435] flex items-center justify-center text-white"><X size={22}/></button>
          <button onClick={prev} className="absolute left-5 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 hover:bg-[#ef2435] flex items-center justify-center text-white"><ArrowLeft size={22}/></button>
          <button onClick={next} className="absolute right-5 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white/10 hover:bg-[#ef2435] flex items-center justify-center text-white"><ArrowRight size={22}/></button>
          <img src={images[zoom]} alt="" className="max-w-[90vw] max-h-[85vh] rounded-2xl"/>
          <p className="absolute bottom-6 left-1/2 -translate-x-1/2 font-mono text-xs text-gray-300">[ {String(zoom+1).padStart(3,'0')} / {String(images.length).padStart(3,'0')} ]</p>
        </div>
      )}
    </main>
  );
}
